/* Card Carousel Presets (isolated to avoid Liquid formatter mangling) */
// Move to metafield guru later?
window.truvaniCardCarouselPresets = {
  plantProteinCards: {
    kicker: "plant based protein powder",
    title: "satisfy your sweet tooth with 13 delicious flavors",
    buttonText: "shop our plant based protein",
    buttonHref: "https://shop.truvani.com/pages/plant-based-protein",
    showButton: true,
    imageLinks: [
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "pumpkin-spice-slider.png",
        title: "pumpkin spice",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "mint-chocolate-slider.jpg",
        title: "mint chocolate",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "lemon-cookie-slider.jpg",
        title: "lemon cookie",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "chocolate-strawberry-slider.jpg",
        title: "chocolate strawberry",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "strawberry-slider.jpg",
        title: "strawberry",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "unflavored-slider.png",
        title: "unflavored",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "matcha-slider.png",
        title: "matcha",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "chocolate-slider.png",
        title: "chocolate",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "vanilla-slider.png",
        title: "vanilla",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "banana-cinnamon-slider.png",
        title: "banana cinnamon",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "chocolate-pb-slider.png",
        title: "chocolate peanut butter",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "vanilla-chai-slider.png",
        title: "vanilla chai",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "peanut-butter-slider.png",
        title: "peanut butter",
      },
    ],
  },
  snackBarsCards: {
    kicker: "the perfect afternoon snack",
    title: "pick your favorite flavor of the only bar",
    buttonText: "shop our snack bars",
    buttonHref: "https://shop.truvani.com/pages/snack-bars",
    showButton: true,
    imageLinks: [
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "chocolate-chip-cookie-dough-slider.jpg",
        title: "chocolate chip cookie dough",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "sugar-cookie-slider.jpg",
        title: "sugar cookie",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "lemon-bar-slider.jpg",
        title: "lemon bar",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "chocolate-chip-banana-bread-slider.jpg",
        title: "chocolate chip banana bread",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "snickerdoodle-slider.jpg",
        title: "snickerdoodle",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "cherry-chocolate-chip-slider.jpg",
        title: "cherry chocolate chip",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "peanut-butter-chocolate-chip-slider.jpg",
        title: "peanut butter chocolate chip",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "chocolate-peanut-butter-slider.jpg",
        title: "chocolate peanut butter",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "chocolate-brownie-slider.jpg",
        title: "chocolate brownie",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "oatmeal-chocolate-chip.jpg",
        title: "oatmeal chocolate chip",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "mint-chocolate-chip-slider.jpg",
        title: "mint chocolate",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "coconut-cashew-slider.jpg",
        title: "coconut cashew",
      },
    ],
  },
  categoryCards: {
    kicker: "all made with ingredients you can trust",
    title: "browse our entire line of products",
    buttonText: "see all our products",
    buttonHref: "",
    showButton: false,
    imageLinks: [
      {
        url: "https://shop.truvani.com/pages/supplements",
        src: "supplements-category-slider.png",
        title: "supplements",
      },
      {
        url: "https://shop.truvani.com/pages/collagen-peptides",
        src: "collagen-category-slider.png",
        title: "collagen",
      },
      {
        url: "https://shop.truvani.com/pages/plant-based-protein",
        src: "protein-category-slider.png",
        title: "protein powders",
      },
      {
        url: "https://shop.truvani.com/pages/snack-bars",
        src: "snack-bar-category-slider.png",
        title: "snack bars",
      },
    ],
  },
};
